/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'flex-start',
  },
});

export default function EmptyTableBase({ className, icon, children }) {
  const classes = useStyles();

  return (
    <div className={clsx(className, classes.container)}>
      {icon}
      {children}
    </div>
  );
}
